// @core/api/endpoints/tenant/list_tenant_data_exports.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTenantDataExportsResponse,
} from '../../../types/tenant';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/tenant';

/**
 * List tenant data exports
 * Returns a list of all data export requests for the tenant, including completed, pending, and failed exports.
 */
export async function ListTenantDataExports(
  tenant_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTenantDataExportsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/data-export`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<ListTenantDataExportsResponse>(requestPath, { ...requestOptions, params });
}
